import { render, staticRenderFns } from "./NotificationDetailDialog.vue?vue&type=template&id=189d0a6a&scoped=true&"
import script from "./NotificationDetailDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDetailDialog.vue?vue&type=style&index=0&id=189d0a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189d0a6a",
  null
  
)

export default component.exports